export enum Environments {
  Development = 'dev',
  Production = 'prod',
  QA = 'qa',
  Staging = 'stg',
}